module.exports = __webpack_public_path__ + "5f621aebc84d524b5d202fd86775b136.png";